import { nanoid } from 'nanoid';
import React from 'react';

import { ISCBMultipleImageText } from 'types/interfaces/sulu/IContentBlocks';

import ImageWithText from './ImageWithText';
import Reveal from './Reveal';

const MultipleImageText = ({
  title,
  images,
  has_orchid_theme,
}: ISCBMultipleImageText) => (
  <>
    {title && (
      <Reveal>
        <h2
          className={`text-center mb-10 ${
            has_orchid_theme ? 'text-orchid' : ''
          }`}
        >
          {title}
        </h2>
      </Reveal>
    )}
    {images.map((imageWithText, i) => (
      <ImageWithText
        key={nanoid()}
        orientation={i % 2 ? 'left' : 'right'}
        {...imageWithText}
      />
    ))}
  </>
);

export default MultipleImageText;
